import log from 'thinkingdata-browser'
import { getDeviceId, getSessionId } from '@/utils'
import { localeToRegionIdMap, uniteTenementId } from '@/config/const'
import store from '@/store'
const isAndroid = /Android/i.test(navigator.userAgent)
const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
const platform = isAndroid ? 'Android' : isIOS ? 'IOS' : 'PC'

export default {
  install: (app) => {
    const config = {
      appId: process.env.VUE_APP_LOG_APP_ID,
      serverUrl: process.env.VUE_APP_LOG_URL
    }
    log.init(config)
    log.setSuperProperties({
      device_id: getDeviceId(),
      channel: 'minifire_payment_web',
      session_id: getSessionId(),
      platform,
      project: location.host,
    })
    const proxyLog = new Proxy(log, {
      get: (target, prop) => {
        if (prop === 'track') {
          target.setSuperProperties({
            account_id: store.state.actUserInfo.uid || '',
            "#account_id": store.state.actUserInfo.uid || '',
            aggregation_id: store.state.actUserInfo.uid || '',
            region_id: localeToRegionIdMap[store.state.locale],
            tenement_id: uniteTenementId,
            language: store.state.locale,
            upload_time: Math.floor(new Date().getTime() / 1000),
          })
          return (event, properties) => {
            target.track(event, properties)
          }
        }
      }
    })
    app.config.globalProperties.$actlog = proxyLog
  }
}
